import Microgame from '../engine/Microgame.js';

export default class CrushGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Écrase !`, en: `Crush!`, es: `¡Aplasta!` },
            controls: { fr: `Attends que l'objet soit au milieu des pistons et appuie !`, en: `Wait for the object to be between pistons and tap!`, es: `Espera a que el objeto esté entre los pistones y toca` },
            objective: { fr: `Écrase l'objet sans le rater`, en: `Crush the object without missing`, es: `Aplasta el objeto sin fallar` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M3 10V2h18v8"/><path d="M3 14v8h18v-8"/><circle cx="12" cy="12" r="2"/></svg>`,
            actions: [
                { type: 'wait', duration: 240 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3800
        };
    }
    constructor(engine) {
        super(engine);
        this.can = null;
        this.taps = 0;
        this.maxTaps = 8;

        // Difficulty scaling (make speed 4 equal to old speed 3.3 by using 0.47)
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeedScale = 1 + (speedMult - 1) * 0.47;
        this.duration = 3000 * (speedMult / adjustedSpeedScale);
    }

    setup() {
        this.engine.ui.instruction.textContent = "CRUSH!";

        // Can (Primary)
        this.can = document.createElement('div');
        this.can.style.position = 'absolute';
        this.can.style.width = '120px';
        this.can.style.height = '200px';
        this.can.style.background = this.primaryColor;
        this.can.style.top = '50%';
        this.can.style.left = '50%';
        this.can.style.transform = 'translate(-50%, -50%)';
        this.can.style.borderRadius = '10px';
        this.can.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.can.style.transition = 'height 0.1s, width 0.1s, transform 0.1s';
        this.container.appendChild(this.can);

        // Rim Top
        const rimTop = document.createElement('div');
        rimTop.style.position = 'absolute';
        rimTop.style.width = '100%';
        rimTop.style.height = '10px';
        rimTop.style.background = '#fff';
        rimTop.style.opacity = '0.5';
        rimTop.style.top = '0';
        rimTop.style.borderRadius = '10px 10px 0 0';
        this.can.appendChild(rimTop);

        // Rim Bottom
        const rimBottom = document.createElement('div');
        rimBottom.style.position = 'absolute';
        rimBottom.style.width = '100%';
        rimBottom.style.height = '10px';
        rimBottom.style.background = '#fff';
        rimBottom.style.opacity = '0.5';
        rimBottom.style.bottom = '0';
        rimBottom.style.borderRadius = '0 0 10px 10px';
        this.can.appendChild(rimBottom);

        // Label/Logo (Secondary)
        const label = document.createElement('div');
        label.style.position = 'absolute';
        label.style.width = '80%';
        label.style.height = '40px';
        label.style.background = this.secondaryColor;
        label.style.top = '40%';
        label.style.left = '10%';
        label.style.transform = 'rotate(-10deg)';
        label.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.can.appendChild(label);

        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (this.won) return;

        this.taps++;

        // Visual Crunch
        const progress = this.taps / this.maxTaps;
        const newHeight = 200 * (1 - progress * 0.7); // Crush down to 30%
        const newWidth = 120 * (1 + progress * 0.3); // Bulge out

        this.can.style.height = `${newHeight}px`;
        this.can.style.width = `${newWidth}px`;

        // Random tilt/distortion
        const rot = (Math.random() - 0.5) * 20 * progress;
        this.can.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;

        // Add crinkle lines
        this.addCrinkle();

        if (this.taps >= this.maxTaps) {
            this.win();
            this.can.style.transform = `translate(-50%, -50%) scaleY(0.1) scaleX(1.5)`;
            this.can.style.opacity = '0.8';
        }
    }

    addCrinkle() {
        const crinkle = document.createElement('div');
        crinkle.style.position = 'absolute';
        crinkle.style.width = '100%';
        crinkle.style.height = '2px';
        crinkle.style.background = '#000';
        crinkle.style.opacity = '0.3';
        crinkle.style.top = `${Math.random() * 100}%`;
        crinkle.style.transform = `rotate(${Math.random() * 20 - 10}deg)`;
        this.can.appendChild(crinkle);
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
